import type { CompanySubscriptionData } from "../../types/admin/SubscriptionTypes";

const EMPTY: CompanySubscriptionData = { plans: [], features: [], available_roles: [] };

// Clinic plan data from /me, held in memory for the route guards; the `subscriptions` cookie is retired (contract §3).
let current: CompanySubscriptionData | null = null;

const copy = (data: CompanySubscriptionData): CompanySubscriptionData => ({
	plans: [...(data.plans ?? [])],
	features: [...(data.features ?? [])],
	available_roles: [...(data.available_roles ?? [])],
});

export const setSubscriptions = (subscriptions: CompanySubscriptionData | null | undefined): void => {
	current = subscriptions ? copy(subscriptions) : null;
};

export const clearSubscriptions = (): void => {
	current = null;
};

export const getSubscriptions = (): CompanySubscriptionData => copy(current ?? EMPTY);

export const hasFeature = (feature: string): boolean =>
  getSubscriptions().features.includes(feature);

export const hasSubscription = (planSlug: string): boolean =>
  getSubscriptions().plans.includes(planSlug);

export const getAvailableRoles = (): string[] =>
  getSubscriptions().available_roles;

export const hasActivePlans = (): boolean =>
  getSubscriptions().plans.length > 0;
